import { render } from "./formularioCreche.vue?vue&type=template&id=67ad713a&scoped=true"
import script from "./formularioCreche.vue?vue&type=script&lang=js"
export * from "./formularioCreche.vue?vue&type=script&lang=js"

import "./formularioCreche.vue?vue&type=style&index=0&id=67ad713a&lang=css"
import "./formularioCreche.vue?vue&type=style&index=1&id=67ad713a&lang=scss&scoped=true"
import "./formularioCreche.vue?vue&type=style&index=2&id=67ad713a&scoped=true&lang=css"
import "./formularioCreche.vue?vue&type=style&index=3&id=67ad713a&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-67ad713a"]])

export default __exports__